import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CardVisualsSection from './components/CardVisualsSection';
import BenefitsSection from './components/BenefitsSection';
import LifestyleSection from './components/LifestyleSection';
import FooterSection from '../HomePage/components/FooterSection';
import Navigation from '../../components/ui/Navigation';
import LanguageToggle from '../../components/ui/LanguageToggle';
import Button from '../../components/ui/Button';

const CardBenefitsPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');
  const navigate = useNavigate();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }

    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const content = {
    EN: {
      title: "Your PSPXpress Card & Benefits",
      subtitle: "A reloadable Mastercard® Prepaid Card designed to support your financial journey",
      getYourCard: "Get Your Card"
    },
    FR: {
      title: "Votre carte et avantages PSPXpress",
      subtitle: "Une carte Mastercard® prépayée rechargeable conçue pour soutenir votre parcours financier",
      getYourCard: "Obtenez votre carte"
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <div className="min-h-screen bg-background">
      {/* Language Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Navigation */}
      <Navigation currentLanguage={currentLanguage} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-blue-800">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {text?.title}
          </h1>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            {text?.subtitle}
          </p>
          <Button
            variant="default"
            size="lg"
            onClick={() => navigate('/apply')}
            className="bg-white text-primary hover:bg-gray-50 font-semibold px-8 py-4 text-lg"
            iconName="ArrowRight"
            iconPosition="right"
          >
            {text?.getYourCard}
          </Button>
        </div>
      </section>

      {/* 3D Card Visuals */}
      <CardVisualsSection currentLanguage={currentLanguage} />

      {/* Key Benefits */}
      <BenefitsSection currentLanguage={currentLanguage} />

      {/* Lifestyle Imagery */}
      <LifestyleSection currentLanguage={currentLanguage} />

      {/* Footer */}
      <FooterSection currentLanguage={currentLanguage} />
    </div>
  );
};

export default CardBenefitsPage;